{
  "#DOCUMENTATION": {
    "APP": "Dokumentation",
    "TITLE": "Neue Dokumentation",
    "ACTION": {
      "SCAN_ORDER": "Auftrag Scannen",
      "RECENT_OBJECTS": "Letzte Objekte"
    },
    "CREATE": {
      "OBJECTNUMBER": "Objekt",
      "DATE": "Datum",
      "TITLE": "Titel",
      "DESCRIPTION": "Beschreibung",
      "SUBMIT": "Speichern"
    },
    "DIALOG": {
      "TITLE": "Zuletzt benutzte Objekte",
      "DESC": "Tippen Sie auf das gewünschte Objekt um es auszuwählen"
    }
  }
}
